<template>
  <div>
    <h1>rdTest</h1>
    <div
      id="crownix-viewer"
      style="position: absolute; width: 100%; height: 100%"
    ></div>
    <div>
      <v-btn @click="callRD()">RD호출</v-btn>
    </div>
  </div>
</template>

<script>
import { loadScript } from 'vue-plugin-load-script';
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {
    loadScript(
      // 'https://ehr.bgf.co.kr/ReportingServer/html5/js/crownix-viewer.min.js',
      'http://ehr.bgf.co.kr/ReportingServer/html5/js/crownix-viewer.min.js',
    );
  },
  methods: {
    callRD() {
      // alert('step1');
      // eslint-disable-next-line no-undef
      // console.log('asd');
      // eslint-disable-next-line no-undef, no-unused-vars
      const viewer = new m2soft.crownix.Viewer(
        // 'https://ehr.bgf.co.kr/ReportingServer/service',
        'http://ehr.bgf.co.kr/ReportingServer/service',
        'crownix-viewer',
      );
      // alert('step2');
      const mrd =
        //   //'https://hr.workup.plus/cloudhr/statics/task/mrd/emp/PersonInfoCard.mrd';
        //   //'https://ehr.bgf.co.kr/html/report/hrm/empcard/PersonInfoCardType10.mrd';
        '%cc%17%be%1e%03%f4%23%ad%f1%f3%f5%f7%08%f6%f4%f2%2c%fd%19%82%f5%d8%05%bc%d9%04%8b%03%9fC%17%0b%d0i%c6%3cwE%a3%b2T%f3G%bc%0fRN%06%3bW%3dx%ff%96%0b%11b%c3lz%b3%26%0e%60%a1%fd%d0%a4%5e%88%83%2dX%dc%9e%d6%f5%bf%c1%f9%a7%cb%0b%0aG%bdh%88%5e%d9D%b4j%f7%2b%05';
      const param =
        //   //"/rfn [https://hr.workup.plus/DataServer/rdagent.jsp] /rsn [CLOUD_HR] /rreportopt [256] /rmmlopt [1] /rpdfexportapitype [0] /rp [,('HR','101325')] [https://hr.workup.plus] [N] [Y] [Y] [Y] [Y] [Y] [HR] ['101325'] [] ['101325'] [] [] [Y] [N] [Y] [Y] [Y] [Y] [Y] [] [Y] [Y] [] [Y] [Y] [BArNjG+Ea8q0UtrA7vS1ELw7ca3pp4Cvd2H4iXmOkic=] /rv securityKey[BArNjG+Ea8q0UtrA7vS1ELw7ca3pp4Cvd2H4iXmOkic=]";
        //   //"/rfn [https://ehr.bgf.co.kr/DataServer/rdagent.jsp] /rsn [EHR_BGF] /rreportopt [256] /rmmlopt [1] /rp [ ,('10','22210376') ] [ https://ehr.bgf.co.kr ]  [Y] [Y] [Y] [Y] [Y] [Y] [Y] [Y] [Y] [Y] [Y] [Y]";
        '%ae%d6%cc%8a%94%c3%0d%ce%f1%f3%f5%f7%08%f6%f4%f2%c7%60%b83%a8x%ba%a4m%06l%7f%eb%ef%c6%24%a9%b5%2c%99%95WPa1%9c%7d%03%28%d8%9d%3ds%28n%c0%7d%f4%be%fe%89%2cl%7b%de%d6%405%19b%b0U%21%b4%d3R%2aq%2d1%83lI%e1%26%29%2b%a6%86%88%bc%12N%23%c0%f5V%16%dcFxJs%bf%95%aa%9e%9a%cf%94%de%1b%c1g%06An%feh%e4%28Z%ea%5deO%d5z%a8%c9%cc%df%fd%06%bd%ca%81%b0R%e5%3c%84k%94%fb%ea%29%d1%27a%09%b5%5e%82%b6%f5%e60%d1vp%9e%06T%c4B%04%83%1fU3%29g%c5R%5c%00%9c%ce%10%f8%fa%ab%ba%bb%fdP%bd%84tkM%a2%bd%c8%0f%f8%fa%ab%ba%bb%fdP%bd%84tkM%a2%bd%c8%0fI%fc%e8Y%cb%ac%19%21%25%01%07+%f1v%98%b1';
      viewer.setParameterEncrypt(11);
      // alert('step3');
      viewer.openFile(mrd, param);
    },
  },
};
</script>

<style scoped></style>
